<template>
  <div>
    <el-row class="tac">

      <el-col  class="contain" >

        <div style="padding-top: 20px;" v-show="gv" >
          <h2 style="text-align: center;padding-bottom: 20px">{{titles[0]}}</h2>
          <el-form ref="form"  :model="form"
                   :rules="rules">
            <el-row>
              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[0]" prop="Frequency">
                  <el-input  v-model.number="form.Frequency"  :placeholder="placeholders[0]" />
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[1]" prop="dianliumidu">
                  <el-input  v-model.number="form.dianliumidu" :placeholder="placeholders[1]"  />
                </el-form-item>
              </el-col>

              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[2]" prop="chuangkou">
                  <el-input v-model.number="form.chuangkou" :placeholder="placeholders[2]"  />
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[3]" prop="citongmidu">
                  <el-input  v-model.number="form.citongmidu" :placeholder="placeholders[3]"  />
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[4]" prop="gonglvdayu">
                  <el-input  v-model.number="form.gonglvdayu" :placeholder="placeholders[4]"  />
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[5]" prop="gonglvxiaoyu">
                  <el-input  v-model.number="form.gonglvxiaoyu" :placeholder="placeholders[5]"  />
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[6]" prop="ALdayu">
                  <el-input  v-model.number="form.ALdayu" :placeholder="placeholders[6]"  />
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="20" :md="11" :lg="11" :xl="11" >
                <el-form-item :label="labels[7]" prop="Aedayu">
                  <el-input v-model.number="form.Aedayu"  :placeholder="placeholders[7]"  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11" style="text-align: center;">

                <el-button type="primary" @click="zj" :loading=loading>{{buttons[3]}}</el-button>
                <el-button type="primary" @click="qq" :loading=loading>{{buttons[4]}}</el-button>
                <el-button type="warning" @click="guanbi">{{buttons[5]}}</el-button>


              </el-col>
            </el-row>



          </el-form>

        </div>

        <div >
          <!--                    <a  @click="find">全部</a>-->
          <a v-for="(value,index) in Categories" @click="find">{{value}}</a>
        </div>
        <div>
          <el-table
              :data="tableData"
              border
              style="width: 100%"
              stripe
              empty-text="No Data"
          >

            <el-table-column
                prop="name"
                label="name"
            >
            </el-table-column>  <el-table-column
              prop="A"
              label="A"
          >
          </el-table-column>
            <el-table-column
                prop="B"
                label="B"
            >
            </el-table-column>
            <el-table-column
                prop="C"
                label="C">
            </el-table-column>
            <el-table-column
                prop="E"
                label="E">
            </el-table-column>
            <el-table-column
                prop="F"
                label="F">
            </el-table-column>
            <el-table-column
                prop="G"
                label="G">
            </el-table-column>
            <el-table-column
                prop="H"
                label="H">
            </el-table-column>
            <el-table-column
                prop="I"
                label="I">
            </el-table-column>
            <el-table-column
                prop="J"
                label="J">
            </el-table-column>
            <el-table-column
                prop="Ae"
                label="Ae">
            </el-table-column>
            <el-table-column
                prop="Al"
                label="Al">
            </el-table-column>
            <el-table-column
                prop="wtg"
                label="wtg">
            </el-table-column>
          </el-table>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "search",
  data(){
    return{
      path:this.$route.path,//设置菜单高亮
      form:{chuangkou:0.4},
      al:{},
      ae:{},
      titles:["Die qualifizierten Kerninformationen werden entsprechend der Ausgangsleistung abgefragt",
        "Die förderfähigen Kerninformationen werden nach AL abgefragt",
        "Die förderfähigen Kerninformationen werden nach Ae abgefragt"],
      labels:["Frequenz","Stromdichte","Fensterfüllfaktor",
        "Magnetische Flussdichte", "Power Min", "Power Max",
        "AL Min", "Ae Min","AL Max","Ae Max",],
      placeholders:["Frequenzeinheit:KHz","Einheit: A/mm² Max 4A/mm²",
        "Einheit: KW allgemein benutzt 0.4", "Einheit: T 1T=1000mT",
        "Einheit: W", "Einheit: W",
        "Mehr als das, schreibe 0 für alle",
        "Größer als dies, schreibe 0 für alle",
        "Suche nach AL größer oder gleich diesem Wert",
        "Suche nach AL kleiner oder gleich diesem Wert",
        "Suche nach Ae größer oder gleich diesem Wert",
        "Suche nach Ae kleiner oder gleich diesem Wert",
      ],
      buttons:["Ausgangsleistungsabfrage","Entsprechend AL-Abfrage","Entsprechend Ae-Abfrage",
        "Vorwärtszeichnung", "Vollbrücke Push-Pull", "Schließen", "Absenden"],
      tableData:null,
      tableData2:null,
      Categories:null,
      loading:false,
      gv: true,
      aldiv:false,
      aediv:false,
      isPC:'true',
      rules:{

        Frequency:[
          { required: true, message: "Frequenz ist ein Muss", trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "Der Frequenzwert darf nicht negativ sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}

        ],
        dianliumidu:[
          { required: true, message: 'Stromdichte ist ein Muss', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0||value>4){
                  tip = "Der Stromdichtewert darf nicht negativ sein und der Maximalwert darf 4 nicht überschreiten"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}
        ],
        chuangkou:[
          { required: true, message: 'Fensterkoeffizienten sind erforderliche Daten', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "Die Fensterkoeffizienten können nicht negativ sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}

        ],
        citongmidu:[
          { required: true, message: 'Magnetische Flussdichte ist ein Muss', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "Der Wert der magnetischen Flussdichte darf nicht kleiner als 0 sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}
        ],
        gonglvdayu:[
          { required: true, message: 'Die untere Leistungsgrenze ist die benötigte Datenmenge', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "Die untere Grenze der Leistung kann nicht kleiner als 0 sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}
        ],
        gonglvxiaoyu:[
          { required: true, message: 'Die Leistungsgrenze ist erforderlich Daten', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "Der obere Grenzwert darf nicht kleiner als 0 sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}
        ],
        ALdayu:[
          { required: true, message: 'AL sind erforderliche Daten', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "AL-Wert darf nicht kleiner als 0 sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}
        ],
        Aedayu:[
          { required: true, message: 'Ae sind erforderliche Daten', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "Ae-Wert darf nicht kleiner als 0 sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}
        ],
        great:[
          { required: true, message: 'Dieser Wert ist erforderlich', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "Wert darf nicht kleiner als 0 sein"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}
        ],

      }

    }
  }
  ,methods:{

    zj(){

      this.submit('form',"/search/zhengjituoba",this.form)

    },
    qq(){
      this.submit('form',"/search/quanqiaotuiwan",this.form)

    },

    submit(refs,url,data){
      this.$refs[refs].validate((valid) => {
        if (valid){

          request.post(url,data).then(res =>{
            if (res.code=='200'&res.data.length!=0){
              var arr=['全部']
              this.tableData=null
              this.loading=false
              this.tableData=res.data
              this.tableData2=res.data
              for (var i=0;i<res.data.length;i++){


                if (arr.indexOf(res.data[i].name.match(/[A-z]+/ig)[0])==-1){
                  arr.push(res.data[i].name.match(/[A-z]+/ig)[0])
                }
              }
              this.Categories=arr;

            }else if (res.data.length==0){

              this.$message({
                type:"success",
                message:"Es liegen keine Daten vor, die den Anforderungen entsprechen"
              })
            }else{
              this.loading=false
              this.$message({
                type:"error",
                message:res.data
              })
            }

          })

        }else{

        }

      })
    },

    find(event){
      // console.log(event.target.innerText)
      var Data=this.tableData2;
      if (event.target.innerText=="全部"){
        this.tableData=this.tableData2;

      }else {


        var arr = [];
        for (let i = 0; i < Data.length; i++) {
          //判断是不是已**开头，如果是已**开头就放到数组里面
          if (Data[i].name.indexOf(event.target.innerText) != -1) {
            arr.push(Data[i])
          }
        }
        this.tableData = arr;
      }
    }
    ,guanbi(){
      this.$emit('changeMsg', true)
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  created() {
    if (this._isMobile()) {
      if(this._isMobile().indexOf("iPad")!=-1){
        this.isPC=true;
      }else {
        this.isPC=false;
      }

    } else {
      // alert("pc端");
      // this.$router.replace('/test');
      this.isPC=true;
    }
  },

}
</script>


<style scoped>
a{
  text-decoration:underline ;
  color: #409EFF;
  cursor: pointer;
  display: inline-block;
  width: 90px;
  text-align: center;
  line-height: 30px;
  margin-left: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-bottom: 5px;
}
.tac{
  height: calc(100vh - 70px);
}



/* 隐藏整个元素的滚动条 */
.scroll-container {
  overflow-y: scroll; /* 或者 overflow-x: scroll; */
}

/* 隐藏滚动条 */
.scroll-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari 和 Opera */
}

/* Firefox */
.scroll-container {
  scrollbar-width: none;
}



.demo-image .block {
  padding: 10px 0;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}

</style>



